import { NEW_CONTENT } from '../types';
import { createAction } from '@reduxjs/toolkit';

export const newContent = createAction<void, typeof NEW_CONTENT>(NEW_CONTENT);
